module.exports = __webpack_public_path__ + "static/media/Stripelogo.875a4de7.svg";